import { slideDown, slideUp, slideStop, isVisible } from "slide-anim";
import { listen, qsa, add, contains } from "@fluorescent/dom";

const selectors = {
  headings: ".accordion__heading",
  labels: ".accordion__label",
};

const accordion = node => {
  node.classList.add("accordion--active");
  const headings = qsa(selectors.headings, node);
  const labels = qsa(selectors.labels, node);

  headings.forEach(heading => {
    if (!contains(heading, "type-heading-2")) add(heading, "type-heading-2");
  });

  labels.forEach(label => {
    if (!contains(label, "type-heading-3")) add(label, "type-heading-3");
  });

  const events = [];

  const _handleAnimation = e => {
    const { parentNode: group, nextElementSibling: content } = e.currentTarget;
    e.preventDefault();
    slideStop(content);

    if (isVisible(content)) {
      slideUp(content);
      e.currentTarget.setAttribute("aria-expanded", false);
      group.setAttribute("data-open", false);
      content.setAttribute("aria-hidden", true);
    } else {
      slideDown(content);
      e.currentTarget.setAttribute("aria-expanded", true);
      group.setAttribute("data-open", true);
      content.setAttribute("aria-hidden", false);
    }
  };

  labels.forEach(label => {
    if (label.tagName === "A") {
      label.href = "#";
    }
    events.push(listen(label, "click", e => _handleAnimation(e)));
  });

  const unload = () => {
    events.forEach(event => {
      event.element.removeEventListener(event.action, event.function);
    });
  };

  return { unload };
};

export default accordion;
